<template>
  <div :class="`custom-table ${customClass} ${firstCellImage ? 'with-first-cell-image' : ''} ${newDesign ? 'new-table-design' : ''}`">
    <div v-if="newDesign" :class="newDesign ? 'main-header-table' : ''">
      <div class="custom-theader">
        <slot name="theader"></slot>
      </div>
    </div>
    <div v-if="!newDesign" class="custom-theader">
      <slot name="theader"></slot>
    </div>
    <div class="custom-tbody">
      <slot name="tbody"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomTable',
  props: [
    'firstCellImage',
    'customClass',
    'newDesign'
  ]
}
</script>

<style lang="scss">
  .new-table-design {
    .main-header-table {
      display: table-caption;
    }
    .sticky-header-table {
      position: sticky;
      z-index: 11;
      transition: top 0.001s;
    }
    .custom-theader {
      .table-cell {
        text-transform: uppercase;
        font-size: 12px;
        color: $dove-gray;
        padding-left: 3px;
        padding-right: 3px;
      }

      .custom-row {
        border-bottom: 1px solid $white;
      }

      .active {
        background-color: $dark-gray;
        border-bottom: none;
        .table-cell {
            color: #ffffff;
            font-weight: 400;
            font-size: 14px;
            text-transform: none;
        }
      }
    } 

    .custom-tbody .custom-row {
      .table-cell {
        height: 60px;
        padding-left: 3px;
        padding-right: 3px;
      }
    } 

    .order-link-wrapper.active {
      color: $sea-buckthorn;
    }
  }
</style>
